import "../layout.scss";
import {ReactNode, useEffect} from "react";
import MeasureList from "../components/measure-list.tsx";
import StatisticsList from "../components/statistics-list.tsx";
import PlusMenu from "../components/plus.tsx";
import House from "../components/house.tsx";
import { clsx } from "../functions.ts";
import { useStore } from "../state/state.ts";
import View, { H, P, ViewCopy, ViewCopyLong } from "../components/view.tsx";
import ModalHeizungFuture from "../modals/modal_heizung_future.tsx";
import ModalKellerFuture from "../modals/modal_keller_future.tsx";
import ModalFensterFuture from "../modals/modal_fenster_future.tsx";
import ModalFassadeFuture from "../modals/modal_fassade_future.tsx";
import ModalSolarthermieFuture from "../modals/modal_solarthermie_future.tsx";
import ModalPhotovoltaikFuture from "../modals/modal_photovoltaik_future.tsx";
import ModalLueftungFuture from "../modals/modal_lueftung_future.tsx";
import ModalDachFuture from "../modals/modal_dach_future.tsx";
import ModalKostengrundlage from "../modals/modal_kostengrundlage.tsx";
import StatisticsEnergiesparklasse from "../components/statistic/statistics-energiesparklasse.tsx";

export default function ViewFutureState() {
  const selected_menu_item = useStore((state) => state.selected_menu_item);
  const keep_menu_open = useStore((state) => state.keep_menu_open);

   const dialogs : Record<string, ReactNode> = {
      heizung: <ModalHeizungFuture />,
      dach: <ModalDachFuture />,
      keller: <ModalKellerFuture />,
      fenster: <ModalFensterFuture />,
      fassade: <ModalFassadeFuture />,
      solarthermie: <ModalSolarthermieFuture />,
      photovoltaik: <ModalPhotovoltaikFuture />,
      lueftung: <ModalLueftungFuture />,
      // kostengrundlage: <ModalKostengrundlage />,
  };

  return <View>
    <div className="layout">
          <div className="layout__col layout__col-left">
            <ViewCopy style={{marginBottom: 0}}>
              <H>Modernisierung simulieren und Energieeffizienz steigern!</H>
              <P>Welche Modernisierung ist geplant? Die Bauteile in der Liste oder im 3D-Haus anklicken und die Details zur Modernisierung auswählen.</P>
            </ViewCopy>
            <h2>Geplante Sanierungsmaßnahmen:</h2>
            <MeasureList />
          </div>
          <div className="layout__col layout__col-center">
            <StatisticsEnergiesparklasse />
            <StatisticsList/>
            <House dialogs={dialogs}/>
          </div>
      </div>
    </View>
}
